<template>
  <div class="footer">
    <a-row v-if="footerData">
      <a-col :span="6"
             class="flex-row-start">
        <div class="left flex-row-start">
          <img :src="footerData.phone"
               alt="">
          <div>
            <div>咨询电话</div>
            <div>{{companyPhone}}</div>
          </div>
        </div>
      </a-col>
      <a-col :span="18">
        <div class="right flex-column-center">
          <!-- <div>
            <span class="item"
                  v-for="(item, index) in navList"
                  :key="index" @click="navTo(item, index)">{{item.name}}</span>
          </div> -->
          <div class="flex-row-center"><a href="https://beian.miit.gov.cn/"
               target="_blank">{{footerData.beian}}</a><span v-html="footerData.copyright"></span></div>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import HeaderFooterData from "../../assets/datas/HeaderFooterData.json";
export default {
  name: 'Footer',
  data () {
    return {
      footerData: null,
      navList: [],
      companyPhone: ''
    }
  },
  watch: {
    '$store.state.companyPhone':{
      handler(){
        this.companyPhone = this.$store.state.companyPhone
      },
      deep: true
    },
  },
  mounted () {
    this.fatchData()
    this.companyPhone = this.$store.state.companyPhone
  },
  methods: {
    fatchData () {
      this.footerData = HeaderFooterData.footer
      this.navList = HeaderFooterData.navList
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  width: 100%;
  height: 1.68rem;
  padding: 0 5%;
  box-sizing: border-box;
  text-align: center;
  background-color: #62ade8;
  .left {
    img {
      width: 0.3rem;
      height: 0.3rem;
      margin-right: 0.16rem;
    }
    div {
      font-size: 0.25rem;
      text-align: left;
      color: #ffffff;
    }
  }

  .right,
  a {
    color: #ffffff;
  }

  .right {
    .item {
      width: 1.5rem;
      display: inline-block;
      height: 0.5rem;
      line-height: 0.5rem;
    }
  }
}
/deep/.ant-row {
  height: 100%;
}

/deep/.ant-col {
  height: 100%;
  display: flex;
  justify-content: center;
}
</style>
